import { axios } from "../../../lib/axios";

export const getCTIData = (orgId) => {
  return axios.get(`cti?orgId=${orgId}&getAll=true`);
};

export const retryCallRecordingFetch = (contactId, orgId) => {
  return axios.get(`cti/recording/${contactId}?orgId=${orgId}`);
};

export const getPreSignedURL = (mediaURL, orgId) => {
  return axios.post(`cti/recording?orgId=${orgId}`, { url: mediaURL });
};

export const uploadMediaToS3 = (payload, orgId) => {
  return axios.post(`cti/upload?orgId=${orgId}`, payload);
};

export const getCTIDataByContactID = (contactId, orgId) => {
  return axios.get(`cti?contactId=${contactId}&orgId=${orgId}`);
};
export const getCTIDataByEncounterId = (encounterId, orgId) => {
  return axios.get(`cti?encounterId=${encounterId}&orgId=${orgId}`);
};

export const getCTIDataByPractitionerId = (practitionerId, orgId) => {
  return axios.get(`cti?orgId=${orgId}&practitionerId=${practitionerId}`);
};

export const searchCTIData = (params) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });
  return axios.get(`cti?${query.toString()}`);
};

export const editCTIData = (contactId, orgId, payload) => {
  return axios.put(`cti/${orgId}/${contactId}`, payload);
};